import { DialogContentProps, DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogContentStyled = styled(DialogContent)<DialogContentProps>(() => ({
  '&.MuiDialogContent-root': {
    padding: `0 0 0 0`,
    whiteSpace: 'break-spaces',
  },
}));
